export const formatMarkdownToText = (markdownText) => {
  if (!markdownText || typeof markdownText !== 'string') return '';
  
  let text = markdownText;
  
  text = text.replace(/```json\s*[\s\S]*?```/g, '');
  text = text.replace(/\{\s*"importantPoints"\s*:[\s\S]*\}/g, '');
  text = text.replace(/\*\*([^*]+)\*\*/g, '$1');
  text = text.replace(/\*([^*]+)\*/g, '$1');
  text = text.replace(/`([^`]+)`/g, '$1');
  text = text.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');
  text = text.replace(/^#{1,6}\s+/gm, '');
  text = text.replace(/\\n/g, '\n');
  
  return text.trim();
};

export const formatMarkdownToTextWithBullets = (markdownText) => {
  if (!markdownText || typeof markdownText !== 'string') return '';
  
  let text = markdownText;
  
  text = text.replace(/```json\s*[\s\S]*?```/g, '');
  text = text.replace(/\{\s*"importantPoints"\s*:[\s\S]*\}/g, '');
  text = text.replace(/\*\*([^*]+)\*\*/g, '$1');
  text = text.replace(/\*([^*]+)\*/g, '$1');
  text = text.replace(/`([^`]+)`/g, '$1');
  text = text.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');
  text = text.replace(/^#{1,6}\s+/gm, '');
  text = text.replace(/^-\s+/gm, '• ');
  text = text.replace(/\\n/g, '\n');
  
  return text.trim();
};

export const extractImportantPoints = (content) => {
  if (!content || typeof content !== 'string') return '';
  
  const points = [];
  
  try {
    const parsed = JSON.parse(content);
    if (parsed.importantPoints) {
      const ip = parsed.importantPoints;
      
      if (Array.isArray(ip.visualCuesAndSceneIdeas)) {
        ip.visualCuesAndSceneIdeas.forEach(point => {
          if (point && typeof point === 'string' && point.trim()) {
            points.push(point.trim());
          }
        });
      }
      
      if (Array.isArray(ip.stepByStepDemonstrations)) {
        ip.stepByStepDemonstrations.forEach(point => {
          if (point && typeof point === 'string' && point.trim()) {
            points.push(point.trim());
          }
        });
      }
      
      if (Array.isArray(ip.storytellingAndRelatableExamples)) {
        ip.storytellingAndRelatableExamples.forEach(point => {
          if (point && typeof point === 'string' && point.trim()) {
            points.push(point.trim());
          }
        });
      }
      
      if (Array.isArray(ip.engagementAndPacingEnhancers)) {
        ip.engagementAndPacingEnhancers.forEach(point => {
          if (point && typeof point === 'string' && point.trim()) {
            points.push(point.trim());
          }
        });
      }
      
      if (Array.isArray(ip.additionalNotes)) {
        ip.additionalNotes.forEach(point => {
          if (point && typeof point === 'string' && point.trim()) {
            points.push(point.trim());
          }
        });
      }
      
      if (points.length > 0) {
        return points.map((p, i) => `${i + 1}. ${p}`).join('\n');
      }
    }
  } catch (e) {
  }
  
  let jsonMatch = content.match(/```json\s*([\s\S]*?)```/);
  if (!jsonMatch) {
    jsonMatch = content.match(/\{\s*"importantPoints"\s*:[\s\S]*\}/);
  }
  
  if (jsonMatch) {
    try {
      const jsonStr = jsonMatch[0].replace(/```json\s*/g, '').replace(/```/g, '').trim();
      const jsonData = JSON.parse(jsonStr);
      
      if (jsonData.importantPoints) {
        const ip = jsonData.importantPoints;
        
        if (Array.isArray(ip.visualCuesAndSceneIdeas)) {
          ip.visualCuesAndSceneIdeas.forEach(point => {
            if (point && typeof point === 'string' && point.trim()) {
              points.push(point.trim());
            }
          });
        }
        
        if (Array.isArray(ip.stepByStepDemonstrations)) {
          ip.stepByStepDemonstrations.forEach(point => {
            if (point && typeof point === 'string' && point.trim()) {
              points.push(point.trim());
            }
          });
        }
        
        if (Array.isArray(ip.storytellingAndRelatableExamples)) {
          ip.storytellingAndRelatableExamples.forEach(point => {
            if (point && typeof point === 'string' && point.trim()) {
              points.push(point.trim());
            }
          });
        }
        
        if (Array.isArray(ip.engagementAndPacingEnhancers)) {
          ip.engagementAndPacingEnhancers.forEach(point => {
            if (point && typeof point === 'string' && point.trim()) {
              points.push(point.trim());
            }
          });
        }
        
        if (Array.isArray(ip.additionalNotes)) {
          ip.additionalNotes.forEach(point => {
            if (point && typeof point === 'string' && point.trim()) {
              points.push(point.trim());
            }
          });
        }
      }
    } catch (e) {
      console.error('Error parsing JSON from content:', e);
    }
  }
  
  if (points.length > 0) {
    return points.map((p, i) => `${i + 1}. ${p}`).join('\n');
  }
  
  const formattedContent = formatMarkdownToText(content);
  const lines = formattedContent.split('\n').map(line => line.trim()).filter(line => line);
  let inMainContent = false;
  const numberedPoints = [];
  
  lines.forEach((line) => {
    const trimmed = line.trim();
    if (!trimmed) return;
    
    if (/^main\s+content:?/i.test(trimmed)) {
      inMainContent = true;
      return;
    }
    
    if (/^conclusion:?/i.test(trimmed) || /^call\s+to\s+action:?/i.test(trimmed) || /^\{/.test(trimmed)) {
      inMainContent = false;
      return;
    }
    
    if (inMainContent) {
      if (/^\d+\.\s/.test(trimmed)) {
        const pointMatch = trimmed.match(/^\d+\.\s*(.+)/);
        if (pointMatch) {
          const pointText = pointMatch[1].trim();
          if (pointText.includes('**')) {
            const cleanPoint = pointText.replace(/\*\*/g, '').trim();
            if (cleanPoint) {
              numberedPoints.push(cleanPoint);
            }
          } else {
            const cleanPoint = pointText.split(':')[0].trim();
            if (cleanPoint) {
              numberedPoints.push(cleanPoint);
            }
          }
        }
      }
    }
  });
  
  if (numberedPoints.length > 0) {
    return numberedPoints.map((p, i) => `${i + 1}. ${p}`).join('\n');
  }
  
  return '';
};

export const parseScriptContent = (content) => {
  if (!content || typeof content !== 'string') {
    return {
      title: '',
      subtitle: '',
      introduction: '',
      points: [],
      conclusion: '',
      cta: ''
    };
  }
  
  let cleanContent = content;
  cleanContent = cleanContent.replace(/```json\s*[\s\S]*?```/g, '');
  cleanContent = cleanContent.replace(/\{\s*"importantPoints"\s*:[\s\S]*\}/g, '');
  
  const formattedContent = formatMarkdownToText(cleanContent);
  const lines = formattedContent.split('\n').map(line => line.trim()).filter(line => line && !/^\{/.test(line) && !/```json/i.test(line));
  
  let title = '';
  let subtitle = '';
  let introduction = '';
  let points = [];
  let conclusion = '';
  let cta = '';
  
  let currentSection = '';
  let currentPoint = '';
  let pointTitle = '';
  
  lines.forEach((line, index) => {
    const trimmed = line.trim();
    if (!trimmed) return;
    
    if (/^\{/.test(trimmed) || /```json/i.test(trimmed) || /"importantPoints"/i.test(trimmed)) {
      return;
    }
    
    if (/^hook:?/i.test(trimmed)) {
      currentSection = 'hook';
      const hookText = trimmed.replace(/^hook:?\s*/i, '').trim();
      if (hookText) {
        subtitle = hookText;
      } else if (index + 1 < lines.length) {
        subtitle = lines[index + 1];
      }
      return;
    }
    
    if (/^introduction:?/i.test(trimmed)) {
      currentSection = 'introduction';
      const introText = trimmed.replace(/^introduction:?\s*/i, '').trim();
      if (introText && introText.length > 0) {
        introduction += introText;
      }
      return;
    }
    
    if (/^main\s+content:?/i.test(trimmed) || /^important\s+points?:?/i.test(trimmed)) {
      currentSection = 'points';
      if (currentPoint || pointTitle) {
        points.push({
          title: pointTitle || `Point ${points.length + 1}`,
          description: currentPoint.trim()
        });
        currentPoint = '';
        pointTitle = '';
      }
      return;
    }
    
    if (/^conclusion:?/i.test(trimmed)) {
      currentSection = 'conclusion';
      if (currentPoint || pointTitle) {
        points.push({
          title: pointTitle || `Point ${points.length + 1}`,
          description: currentPoint.trim()
        });
        currentPoint = '';
        pointTitle = '';
      }
      const conclusionText = trimmed.replace(/^conclusion:?\s*/i, '').trim();
      if (conclusionText && !/^\{/.test(conclusionText)) conclusion += conclusionText;
      return;
    }
    
    if (/^call\s+to\s+action:?/i.test(trimmed)) {
      currentSection = 'cta';
      if (currentPoint || pointTitle) {
        points.push({
          title: pointTitle || `Point ${points.length + 1}`,
          description: currentPoint.trim()
        });
        currentPoint = '';
        pointTitle = '';
      }
      const ctaText = trimmed.replace(/^call\s+to\s+action:?\s*/i, '').trim();
      if (ctaText && !/^\{/.test(ctaText)) cta += ctaText;
      return;
    }
    
    if (currentSection === 'hook') {
      if (!subtitle && trimmed.length > 0) subtitle = trimmed;
    } else if (currentSection === 'introduction') {
      if (trimmed.length > 0 && !/^main\s+content/i.test(trimmed)) {
        introduction += (introduction ? ' ' : '') + trimmed;
      }
    } else if (currentSection === 'points') {
      if (/^\d+\.\s/.test(trimmed)) {
        if (currentPoint || pointTitle) {
          points.push({
            title: pointTitle || `Point ${points.length + 1}`,
            description: currentPoint.trim()
          });
        }
        const pointMatch = trimmed.match(/^\d+\.\s*(.+)/);
        if (pointMatch) {
          const pointText = pointMatch[1].trim();
          if (pointText.includes('**')) {
            pointTitle = pointText.replace(/\*\*/g, '').trim();
            currentPoint = '';
          } else if (pointText.includes(':')) {
            pointTitle = pointText.split(':')[0].trim();
            currentPoint = pointText.split(':').slice(1).join(':').trim();
          } else {
            pointTitle = pointText;
            currentPoint = '';
          }
        }
      } else if (currentPoint || pointTitle) {
        if (trimmed.length > 0 && !/^common\s+mistakes/i.test(trimmed) && !/^real\s+example/i.test(trimmed) && !/^visuals?:/i.test(trimmed) && !/^[-*]\s/.test(trimmed)) {
          currentPoint += (currentPoint ? ' ' : '') + trimmed;
        } else if (/^[-*]\s/.test(trimmed)) {
          const subPoint = trimmed.replace(/^[-*]\s*/, '').trim();
          if (subPoint) {
            currentPoint += (currentPoint ? ' ' : '') + subPoint;
          }
        }
      }
    } else if (currentSection === 'conclusion') {
      if (trimmed.length > 0 && !/^call\s+to\s+action/i.test(trimmed) && !/^\{/.test(trimmed) && !/```json/i.test(trimmed) && !/"importantPoints"/i.test(trimmed)) {
        conclusion += (conclusion ? ' ' : '') + trimmed;
      }
    } else if (currentSection === 'cta') {
      if (trimmed.length > 0 && !/^\{/.test(trimmed) && !/```json/i.test(trimmed) && !/"importantPoints"/i.test(trimmed)) {
        cta += (cta ? ' ' : '') + trimmed;
      }
    }
  });
  
  if (currentPoint || pointTitle) {
    points.push({
      title: pointTitle || `Point ${points.length + 1}`,
      description: currentPoint.trim()
    });
  }
  
  return {
    title: title || 'Untitled Script',
    subtitle: subtitle || '',
    introduction: introduction || '',
    points: points.filter(p => p.description && p.description.length > 5),
    conclusion: conclusion || '',
    cta: cta || ''
  };
};

export const parseScriptContentForDetails = (content) => {
  if (!content || typeof content !== 'string') {
    return {
      hook: '',
      introduction: '',
      mainContent: '',
      retentionMoment: '',
      conclusion: '',
      cta: ''
    };
  }
  
  try {
    const parsed = JSON.parse(content);
    if (parsed.script) {
      const script = parsed.script;
      let mainContent = '';
      const sections = [];
      
      if (script.whatIsCoreConcept || script.keyElements) {
        const section = {
          SectionTitle: script.whatIsCoreConcept ? 'What Is / Core Concept' : 'Key Elements',
          Explanation: script.whatIsCoreConcept || script.keyElements || '',
          Steps: [],
          CommonMistakes: [],
          Example: '',
          RetentionMoments: []
        };
        
        if (script.keyElements && !script.whatIsCoreConcept) {
          section.Explanation = script.keyElements;
        }
        
        if (script.settingsTools && Array.isArray(script.settingsTools) && script.settingsTools.length > 0) {
          section.Steps = script.settingsTools.map((tool, idx) => `Step ${idx + 1}: ${tool}`);
        }
        
        if (script.commonMistakes && Array.isArray(script.commonMistakes) && script.commonMistakes.length > 0) {
          section.CommonMistakes = script.commonMistakes;
        }
        
        if (script.extraTip) {
          section.Example = script.extraTip;
        }
        
        if (script.focusingStabilizing && Array.isArray(script.focusingStabilizing) && script.focusingStabilizing.length > 0) {
          section.RetentionMoments = script.focusingStabilizing;
        }
        
        if (section.SectionTitle || section.Explanation) {
          sections.push(section);
        }
        
        if (script.compositionEnhancements && Array.isArray(script.compositionEnhancements) && script.compositionEnhancements.length > 0) {
          mainContent += 'Composition Enhancements:\n' + script.compositionEnhancements.map((t, i) => `${i + 1}. ${t}`).join('\n') + '\n\n';
        }
        if (script.editingRefinement) {
          mainContent += 'Editing & Refinement:\n' + script.editingRefinement;
        }
      } else {
        if (script.whatIsCoreConcept) {
          mainContent += 'Core Concept:\n' + script.whatIsCoreConcept + '\n\n';
        }
        if (script.keyElements) {
          mainContent += 'Key Elements:\n' + script.keyElements + '\n\n';
        }
        if (script.settingsTools && Array.isArray(script.settingsTools)) {
          mainContent += 'Settings & Tools:\n' + script.settingsTools.map((t, i) => `${i + 1}. ${t}`).join('\n') + '\n\n';
        }
        if (script.extraTip) {
          mainContent += 'Extra Tip:\n' + script.extraTip + '\n\n';
        }
        if (script.focusingStabilizing && Array.isArray(script.focusingStabilizing)) {
          mainContent += 'Focusing & Stabilizing:\n' + script.focusingStabilizing.map((t, i) => `${i + 1}. ${t}`).join('\n') + '\n\n';
        }
        if (script.compositionEnhancements && Array.isArray(script.compositionEnhancements)) {
          mainContent += 'Composition Enhancements:\n' + script.compositionEnhancements.map((t, i) => `${i + 1}. ${t}`).join('\n') + '\n\n';
        }
        if (script.commonMistakes && Array.isArray(script.commonMistakes)) {
          mainContent += 'Common Mistakes:\n' + script.commonMistakes.map((t, i) => `${i + 1}. ${t}`).join('\n') + '\n\n';
        }
        if (script.editingRefinement) {
          mainContent += 'Editing & Refinement:\n' + script.editingRefinement;
        }
      }
      
      return {
        hook: script.title || '',
        introduction: script.introduction || '',
        introRollIn: script.introRollIn || '',
        mainContent: mainContent.trim(),
        sections: sections.length > 0 ? sections : null,
        retentionMoment: '',
        conclusion: script.conclusion || '',
        cta: script.callToAction || ''
      };
    }
  } catch (e) {
  }
  
  let cleanContent = content;
  cleanContent = cleanContent.replace(/```json\s*[\s\S]*?```/g, '');
  cleanContent = cleanContent.replace(/\{\s*"importantPoints"\s*:[\s\S]*\}/g, '');
  
  let hook = '';
  let introduction = '';
  let mainContent = '';
  let retentionMoment = '';
  let conclusion = '';
  let cta = '';
  
  let currentSection = '';
  const lines = cleanContent.split('\n');
  
  lines.forEach((line, index) => {
    const trimmed = line.trim();
    if (!trimmed || /^\{/.test(trimmed) || /```json/i.test(trimmed) || /"importantPoints"/i.test(trimmed)) {
      return;
    }
    
    const cleanedLine = trimmed.replace(/^\*\*/, '').replace(/\*\*$/, '').replace(/\*\*:/, ':');
    
    if (/^hook:?/i.test(cleanedLine)) {
      currentSection = 'hook';
      const hookText = cleanedLine.replace(/^hook:?\s*/i, '').trim();
      if (hookText) {
        hook = hookText;
      }
      return;
    }
    
    if (/^introduction:?/i.test(cleanedLine)) {
      currentSection = 'introduction';
      const introText = cleanedLine.replace(/^introduction:?\s*/i, '').trim();
      if (introText) {
        introduction = introText;
      }
      return;
    }
    
    if (/^main\s+content:?/i.test(cleanedLine)) {
      currentSection = 'mainContent';
      return;
    }
    
    if (/^retention\s+moment:?/i.test(cleanedLine)) {
      currentSection = 'retentionMoment';
      const retentionText = cleanedLine.replace(/^retention\s+moment:?\s*/i, '').trim();
      if (retentionText) {
        retentionMoment = retentionText;
      }
      return;
    }
    
    if (/^conclusion:?/i.test(cleanedLine)) {
      currentSection = 'conclusion';
      const conclusionText = cleanedLine.replace(/^conclusion:?\s*/i, '').trim();
      if (conclusionText) {
        conclusion = conclusionText;
      }
      return;
    }
    
    if (/^call\s+to\s+action:?/i.test(cleanedLine)) {
      currentSection = 'cta';
      const ctaText = cleanedLine.replace(/^call\s+to\s+action:?\s*/i, '').trim();
      if (ctaText) {
        cta = ctaText;
      }
      return;
    }
    
    if (currentSection === 'hook') {
      if (trimmed && !/^introduction:?/i.test(trimmed.replace(/^\*\*/, ''))) {
        hook += (hook ? '\n' : '') + trimmed;
      }
    } else if (currentSection === 'introduction') {
      if (trimmed && !/^main\s+content/i.test(trimmed.replace(/^\*\*/, ''))) {
        introduction += (introduction ? '\n' : '') + trimmed;
      }
    } else if (currentSection === 'mainContent') {
      if (trimmed && !/^retention\s+moment:?/i.test(trimmed.replace(/^\*\*/, '')) && !/^conclusion:?/i.test(trimmed.replace(/^\*\*/, '')) && !/^call\s+to\s+action:?/i.test(trimmed.replace(/^\*\*/, ''))) {
        const allLines = mainContent.split('\n').filter(l => l.trim());
        const lastLine = allLines[allLines.length - 1] || '';
        const isNumberedPoint = /^\d+\.\s/.test(trimmed);
        const isFirstPoint = /^1\.\s/.test(trimmed);
        const isSectionHeader = /^(step-by-step|common\s+mistakes|real\s+example|visuals?|example):?/i.test(trimmed);
        const wasSectionHeader = /^(step-by-step|common\s+mistakes|real\s+example|visuals?|example):?/i.test(lastLine);
        
        if (mainContent && mainContent.trim()) {
          if (isNumberedPoint && !isFirstPoint) {
            mainContent = mainContent.trimEnd() + '\n\n' + trimmed;
          }
          else if (isSectionHeader && lastLine.trim() && !wasSectionHeader) {
            mainContent = mainContent.trimEnd() + '\n\n' + trimmed;
          }
          else if (wasSectionHeader && !isSectionHeader) {
            mainContent += '\n' + trimmed;
          }
          else {
            mainContent += '\n' + trimmed;
          }
        } else {
          mainContent = trimmed;
        }
      }
    } else if (currentSection === 'retentionMoment') {
      if (trimmed && !/^conclusion:?/i.test(trimmed.replace(/^\*\*/, '')) && !/^call\s+to\s+action:?/i.test(trimmed.replace(/^\*\*/, ''))) {
        retentionMoment += (retentionMoment ? '\n' : '') + trimmed;
      }
    } else if (currentSection === 'conclusion') {
      if (trimmed && !/^call\s+to\s+action:?/i.test(trimmed.replace(/^\*\*/, ''))) {
        conclusion += (conclusion ? '\n' : '') + trimmed;
      }
    } else if (currentSection === 'cta') {
      if (trimmed) {
        cta += (cta ? '\n' : '') + trimmed;
      }
    }
  });
  
  hook = formatMarkdownToText(hook);
  introduction = formatMarkdownToText(introduction);
  mainContent = formatMarkdownToTextWithBullets(mainContent);
  retentionMoment = formatMarkdownToText(retentionMoment);
  conclusion = formatMarkdownToText(conclusion);
  cta = formatMarkdownToText(cta);
  
  return {
    hook,
    introduction,
    mainContent,
    sections: null,
    retentionMoment,
    conclusion,
    cta
  };
};

export const extractImportantPointsFromJSON = (content) => {
  if (!content || typeof content !== 'string') return null;
  
  try {
    const parsed = JSON.parse(content);
    if (parsed.importantPoints) {
      return parsed.importantPoints;
    }
  } catch (e) {
  }
  
  let jsonMatch = content.match(/```json\s*([\s\S]*?)```/);
  if (!jsonMatch) {
    jsonMatch = content.match(/\{\s*"importantPoints"\s*:[\s\S]*\}/);
  }
  
  if (jsonMatch) {
    try {
      const jsonStr = jsonMatch[0].replace(/```json\s*/g, '').replace(/```/g, '').trim();
      const jsonData = JSON.parse(jsonStr);
      
      if (jsonData.importantPoints) {
        return jsonData.importantPoints;
      }
    } catch (e) {
      console.error('Error parsing JSON from content:', e);
    }
  }
  
  return null;
};
